<template>
  <div>
    <h5>Controles</h5>
    <b-row>
      <b-col sm="4">
        <b-form-group>
          <label for="buscar">Buscar</label>
          <b-form-input
            id="buscar"
            name="buscar"
            type="text"
            v-model="filtroControles.buscar"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="2">
        <b-form-group>
          <label for="estado">Estado</label>
          <el-select
            v-model="filtroControles.estado"
            multiple
            :rows="3"
            :max-rows="6"
            name="estado"
            id="estado"
          >
            <el-option
              v-for="estado in estados"
              :key="estado.value"
              :label="estado.text"
              :value="estado.value"
            >
            </el-option>
          </el-select>
        </b-form-group>
      </b-col>

      <b-col sm="6">
        <b-button
          v-b-modal.modal-1
          variant="primary"
          class="float-right mt-4"
          @click="creaCont"
        >
          <i class="fa fa-plus"></i>
          Crear
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="4" lg="4">
        <b-button-group size="md">
          <b-button
            variant="primary"
            @click.prevent="buscadorControl(filtroControles)"
          >
            <i class="fa fa-search fa-lg"></i>
            <span class="d-none d-md-inline-block ml-1">Buscar</span>
          </b-button>
          <b-button @click.prevent="limpiarControl()">
            <i class="fa fa-eraser fa-lg"></i>
            <span class="d-none d-md-inline-block ml-1"> Limpiar</span>
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <br />

    <b-table
      thead-tr-class="table-active"
      bordered
      responsive
      striped
      hover
      :items="controles.data"
      :fields="columnasControl"
      show-empty
      empty-text="No hay controles para mostrar"
    >
      <template v-slot:cell(activo)="data">
        <b-badge
          v-if="data.item.activo == '1'"
          variant="primary"
          v-text="'Activo'"
        />
        <b-badge v-else variant="danger" v-text="'Inactivo'" />
      </template>
      <template v-slot:cell(actions)="data">
        <a
          v-b-tooltip.hover
          title="Ver Lista de Control"
          class="botonProduct mr-2"
          @click="verListaControl(data.item)"
          ><i class="fa fa-search fa-lg"></i
        ></a>
        <a
          v-b-tooltip.hover
          title="Editar Control"
          class="botonProduct mr-2"
          @click="verControl(data.item.id)"
        >
          <i class="fa fa-edit fa-lg"></i>
        </a>
        <a
          v-b-tooltip.hover
          class="botonProduct"
          :title="data.item.activo ? 'Inactivar' : 'Activar'"
          @click="activarInactivarControl(data.item)"
        >
          <i class="fa fa-close text-danger" v-if="data.item.activo" />
          <i class="fa fa-check text-success" v-else />
        </a>
      </template>
    </b-table>
    <el-pagination
      v-model="filtroControles.page"
      @size-change="setPerPagePaginationControles"
      @current-change="setPagePaginationControles"
      :current-page="filtroControles.page"
      :page-sizes="[10, 30, 50, 100]"
      :page-size="filtroControles.perPage"
      :total="controles.total"
      layout="total, sizes, prev, pager, next"
      class="float-right"
    >
    </el-pagination>
    <br />
    <br />
  </div>
</template>

<script>
import { mapState, mapMutations, MapActions, mapActions } from "vuex";

export default {
  name: "formulario-controles",
  data() {
    return {
      estados: [
        {
          value: 0,
          text: "Inactivo",
        },
        {
          value: 1,
          text: "Activo",
        },
      ],
      columnasControl: [
        {
          key: "codigo",
          label: "Codigo",
          sortable: true,
          thStyle: { "max-width": "85px", width: "85px" },
        },
        {
          key: "control",
          label: "Descripcion",
          sortable: true,
        },
        {
          key: "activo",
          label: "Estado",
          sortable: true,
          thStyle: { "max-width": "85px", width: "85px" },
          tdClass: "text-center",
        },
        {
          key: "actions",
          label: "Opciones",
          thStyle: { "max-width": "95px", width: "95px" },
          tdClass: "text-center",
        },
      ],
    };
  },
  methods: {
    creaCont() {
      this.resetSelectedControl();
      this.$emit("vModalControles", true);
    },
    async verListaControl(data) {
      this.resetFiltroListas();
      this.setNombreControl(data.control);
      this.setFiltLista(data.id);
      await this.getListas();
      this.$emit('cambiarVistaListasControles', 2);
    },
    async buscadorControl(buscar) {
      this.setPageControles(1);
      this.setFiltroControles(buscar);
      await this.getControles();
    },
    async limpiarControl() {
      this.resetFiltroControles();
      await this.getControles();
    },
    async verControl(id) {
      await this.mostrarControl(id);
      this.$emit("vModalControles", true);
    },
    async activarInactivarControl(item) {
      item.activo = item.activo === 1 ? 0 : 1;
      this.setControl(item);
      await this.actualizarControl();
      await this.getControles();
    },
    ...mapMutations("administracion", [
      "resetSelectedControl",
      "setPageControles",
      "setFiltroControles",
      "resetFiltroListas",
      "setFiltLista",
      "setControl",
      "resetFiltroControles",
      "setNombreControl"
    ]),
    ...mapActions("administracion", [
      "getControles",
      "getListas",
      "mostrarControl",
      "actualizarControl",
      "setPerPagePaginationControles",
      "setPagePaginationControles",
    ]),
  },
  computed: {
    ...mapState("administracion", [
      "filtroControles",
      "controles",
      "visualizarModalControles",
    ]),
  },
};
</script>